import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#6cc6d9',
            contrastText: '#fff',
        },
        secondary: {
            main: '#11334b',
            contrastText: '#fff',
        },
        error: {
            main: '#d32f2f',
        },
        background: {
            default: '#f4f6f8',
            paper: '#ffffff',
        },
    },

    shape: {
        borderRadius: 10,
    },

    typography: {
        fontFamily: 'Inter, Roboto, Arial, sans-serif',
        color: '#fff',
        h6: {
            fontWeight: 600,
        },
        subtitle2: {
            fontWeight: 500,
            letterSpacing: 0.3,
        },
        button: {
            textTransform: 'none',
            fontWeight: 500,
        },
    },

    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    backgroundImage: 'none',
                },
            },
        },

        MuiButton: {
            defaultProps: {
                disableElevation: true,
            },
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },

        MuiIconButton: {
            styleOverrides: {
                root: {
                    borderRadius: 8,
                },
            },
        },

        MuiListItemButton: {
            styleOverrides: {
                root: {
                    borderRadius: 6,
                    marginBottom: 2,
                },
            },
        },
    },
});

